<script>
import Loading from "@/components/Loading.vue";
import { K12NET, K12NET_PLATFORMS, k12netRedirectUri } from "@/config/k12net";

/**
 * K12Net SSO giriş adımı.
 *
 * Okul, hedef platformu `?platform=` ile bildirir; biz bunu OAuth `state` parametresine
 * koyup K12Net'in authorize ucuna yönlendiririz. Dönüş K12Net.vue'da karşılanır.
 *
 * Platform listesi ve dönüş adresi @/config/k12net dosyasındadır — eskiden dönüş adresi
 * burada ve K12Net.vue'da ayrı ayrı yazılıydı, OAuth ikisinin birebir aynı olmasını
 * şart koştuğu için yerel akış çalışmıyordu.
 *
 * Örnek: https://service.ueslms.com/#/k12net-redirect/?platform=kidzwonder
 */
export default {
  name: "K12NetRedirect",
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  beforeMount() {
    const platform = this.$route.query.platform;

    if (!platform) {
      this.fail('platform parametresi bulunamadı.');
      return;
    }

    // Tanımsız platformu burada yakalamak önemli: aksi hâlde kullanıcı K12Net'te
    // giriş yapıp geri döndükten sonra hata alıyor, boşuna kimlik doğrulamış oluyor.
    if (!K12NET_PLATFORMS[platform]) {
      this.fail(`Tanımsız platform: ${platform}`);
      return;
    }

    this.loading = true;

    const params = [
      'response_type=code',
      `client_id=${encodeURIComponent(K12NET.clientId)}`,
      `redirect_uri=${encodeURIComponent(k12netRedirectUri())}`,
      `scope=${encodeURIComponent('openid profile')}`,
      `state=${encodeURIComponent(platform)}`,
    ].join('&');

    window.location = `${K12NET.authorizeUrl}?${params}`;
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('K12Net yönlendirme:', message);
    },
  },
}
</script>

<template>
  <div class="flex-center position-ref">
    <Loading :loading="loading"></Loading>
    <div class="content">
      <img src="/assets/logos/k12net.png" alt="K12Net">
      <br /><br /><br />
      <!-- Tanımlı platform listesi bilinçli olarak gösterilmiyor: sayfa herkese açık,
           liste platform anahtarlarını dışarıya sızdırırdı. -->
      <h3 v-if="error" class="k12net-error">{{ error }}</h3>
      <h3 v-else>Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
    </div>
  </div>
</template>

<style scoped>
.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.position-ref {
  position: relative;
}

.content {
  margin-top: 50px;
  text-align: center;
}

.k12net-error {
  max-width: 520px;
  margin: 0 auto;
  color: #ffd6d6;
}
</style>
